import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

/*
import 'firebase/compat/firestore';
import firebase from "firebase/compat/app";
import { getAuth } from "firebase/auth";
*/
import { auth } from "utils/firebase";
import { AdminPrefsDb } from "models/AdminPrefs";
import { UserDb } from "models/User";
import { NewBadgesProvider } from "hooks/useNewBadges";

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        setIsAuthenticated(true);
        try { await AdminPrefsDb.ensureExists(user.uid); } catch (e) { console.warn('[App] ensureAdminPrefs failed:', e); }
        try { await UserDb.ensureAdminUser(user.uid, user.email); } catch (e) { console.warn('[App] ensureAdminUser failed:', e); }
      } else {
        setIsAuthenticated(false);
      }
    });
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <NewBadgesProvider>
            <Routes isAuthenticated={isAuthenticated} />
          </NewBadgesProvider>
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
